import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de fertilizantes foliares
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarFertilizantesFoliares(props) {
  useEffect(() => {
    const title = 'fertilizantesFoliares.cadastroDeFertilizantesFoliares';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'fertilizantes'}
      insumoEnum={Insumo.FERTILIZANTE_FOLIAR}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'fertilizantesFoliares.' +
          (props.match.params.id
            ? 'fertilizantesFoliaresEditadoComSucesso'
            : 'fertilizantesFoliaresCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'fertilizantesFoliares.' +
          (props.match.params.id
            ? 'falhaAoEditarFertilizantesFoliares'
            : 'falhaAoCadastrarFertilizantesFoliares')
      )}
      falhaCarregarMensagem={formatMessage('fertilizantesFoliares.falhaAoCarregarFertilizantesFoliares')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarFertilizantesFoliares));
